<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false">

      <slide>
        <div class="padding">
          <p>I feel like you will read this, and so i can ask you the questions i can't ask others, well some of them, maybe you're reading this now, how could you let me know . . i still can't find you in my memory, but it's not just you now, it's places.</p>
          <br>
          <p>Your face won't fix. Like a clock that's out of joint with the day. Every time i try to hold onto an image of it, there's something missing.</p>
          <br>
          <p>Do you remember the jail in centre of the city, by the park? The thing is that I don't, and yet I stood staring at today while i sat down to eat my lunch on the walls by the park.</p>
          <br>
          <p>Can I be that blind to my own city? The thing is it has always been there, it must have been, everyone else just walked past without glancing, something that big doesn't get constructed overnight, but I don't remember it going up, and yet I find myself remembering things that seem to have disappeared.</p>
          <p> &nbsp;</p>
          <p> &nbsp;</p>
        </div>
      </slide>

    </carousel>
  </div>
</template>

<script>
export default {

  name: '4',

  data () {
    return {
      title: 'Reaching'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
